import { createContext, useContext } from 'react';

export const FinixEnvironmentContext = createContext<'sandbox' | 'live'>(
  (import.meta.env.VITE_FINIX_DEFAULT_ENVIRONMENT as 'sandbox' | 'live') ??
    'sandbox',
);

export const useFinixEnvironment = () => {
  return useContext(FinixEnvironmentContext);
};
